<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BuQLNF/tc-custom/9781558618336.jpg?1726273375064" alt="This image is the cover for the book Pussy Riot!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pussy Riot!
      </h1>
      <p class="bookDescription body article font2">
        <b>Letters from prison, songs, poems, and courtroom statements, plus tributes to the Russian punk band that shook the world.</b><br/><br/>On February 21, 2012, five members of a Russian feminist punk collective Pussy Riot staged a performance in the Cathedral of Christ the Savior in Moscow. Dressed in brightly colored tights and balaclavas, they performed their “Punk Prayer” asking the Virgin Mary to drive out Russian president Vladimir Putin from the church. After just forty seconds, they were chased out by security. Once a retooled video of the events circulated on YouTube (edited to seem much longer than the actual performance), the state was riled into action. Three members of the collective, Maria Alyokhina, Nadezhda Tolokonnikova, and Yekaterina Samutsevich, known as Masha, Nadya, and Katya, were arrested and charged with felony hooliganism motivated by religious hatred, an offense carrying a sentence of up to seven years.<br/><br/>As their trial unfolded, these young women became global feminist icons, garnering the attention and support of activists and artists around the world, including Madonna, Paul McCartney, and Sting, as well as contributors to this book: Yoko Ono, Johanna Fateman, Karen Finley, Justin Vivian Bond, Eileen Myles, and JD Samson. The Internet exploded with petitions, music videos, and calls to action, and as the guilty verdict was anticipated, Pussy Riot responded with articulate, unwavering courtroom statements, calling for freedom of expression, an end to economic and gender oppression, and a separation of church and state. They were sentenced to two years in prison, and inspired a global movement. Collected here are the words that roused the world.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pussy Riot
      </h2>
      
      <p class="authorDescription body article">Pussy Riot: PUSSY RIOT is a feminist punk performance collective based in Moscow. Founded in 2011, they perform public artistic responses to Russian politics. In February of 2012, three members of the group were arrested and charged with felony hooliganism after performing in the sanctuary of the Cathedral of Christ the Savior. Maria Alyokhina, Nadezhda Tolokonnikova, and Yekaterina Samutsevich were sentenced to two years in prison.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feminist Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fba52408